<template>
  <suspense>
    <ContentfulRenderer :component="ContentPage" :content-type="'campaignPage'" :slug="slug" >
      <template v-slot:default="slotProps">
        <CampaignPageMeta v-bind="slotProps" />
      </template>
    </ContentfulRenderer>
  </suspense>
</template>

<script>
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import ContentPage from '@/components/contentful/ContentModels/ContentPage.vue';
import ContentfulRenderer from './ContentfulRenderer.vue';
import CampaignPageMeta from "./CampaignPageMeta.vue";

export default {
  name: 'CampaignPage',
  components: {
    ContentfulRenderer,
    CampaignPageMeta
  },
  setup() {
    const router = useRouter();
    const slug = computed(() => router.currentRoute.value.params?.slug ?? '');

    return {
      ContentPage,
      slug,
    };
  },
};
</script>
